// src/components/common/Footer.jsx
import React, { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import logo from "../assets/images/logos-ravi.png";
import { useVisitorCount } from "./useVisitorCount";   // ✅ import hook
import Loader from "./Loader";                         // ✅ loader for consistency

const TAGLINES = [
  "Exam Success",
  "Test Excellence",
  "Academic Achievement",
];

export function Footer() {
  const [idx, setIdx] = useState(0);
  const visitCount = useVisitorCount(); // ✅ get visitor count

  useEffect(() => {
    const t = setInterval(() => setIdx(i => (i + 1) % TAGLINES.length), 3000);
    return () => clearInterval(t);
  }, []);

  return (
    <footer className="bg-gray-50 text-gray-800">
      {/* Tagline Hero */}
      <motion.div
        className="max-w-3xl mx-auto text-center py-12 px-4 bg-gradient-to-r from-blue-600 via-blue-700 to-indigo-700 rounded-2xl shadow-lg mt-12"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
      >
        <h2 className="text-2xl md:text-3xl font-bold text-white">
          Learning Begins When The Mind Is Open –
          <AnimatePresence mode="wait">
            <motion.span
              key={TAGLINES[idx]}
              className="text-blue-200 ml-2"
              initial={{ opacity: 0, y: 10 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -10 }}
              transition={{ duration: 0.5 }}
            >
              {TAGLINES[idx]}
            </motion.span>
          </AnimatePresence>
        </h2>
      </motion.div>

      {/* Logo & Tagline */}
      <div className="flex flex-col items-center space-y-8 mt-12 px-4">
        {/* Logo */}
        <motion.img
          src={logo}
          alt="Ravi TestPapers"
          className="h-24"
          initial={{ scale: 0.8, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          transition={{ type: "spring", stiffness: 120, damping: 15 }}
        />

        {/* Animated “One stop destination…” */}
        <AnimatePresence>
          <motion.p
            key={idx}
            className="text-lg text-gray-700"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.5 }}
          >
            One stop destination for{" "}
            <span className="font-semibold text-blue-600">{TAGLINES[idx]}</span>
          </motion.p>
        </AnimatePresence>
      </div>

      {/* Divider */}
      <div className="border-t border-gray-200 my-12 mx-4" />

      {/* ✅ Visitor Count Section */}
      <div className="text-center mb-8">
        <h2 className="text-lg sm:text-xl font-semibold text-blue-600">Visitor Count</h2>
        {visitCount == null ? (
          <Loader />
        ) : (
          <p className="text-blue-500 text-base sm:text-lg mt-2">{visitCount}</p>
        )}
      </div>

      {/* Bottom Bar */}
      <motion.div
        className="text-center text-sm text-gray-500 pb-8"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 1, duration: 0.6 }}
      >
        © {new Date().getFullYear()} Ravi TestPapers. Crafted with care by{" "}
        <a
          href="https://pisence.com"
          className="text-blue-600 hover:underline"
          target="_blank"
          rel="noopener noreferrer"
        >
          PiSence Technologies
        </a>
      </motion.div>
    </footer>
  );
}
